<template>
  <div>
    <div
      class="fip-title"
      data-wptv="fip-title">
      <!-- /!\ tabindex="0" is here to force the focus on it when arriving on the fip - US #6725 -->
      <h1 class="no-signature m-0" tabindex="0">
        {{ `${preTitle} ${item.title}` }}
      </h1>
      <div
        v-if="csa && csa > 1"
        class="icon-csa-wrapper">
        <wptv-icon
          :name="'csa-round' + csa"
          :invert="true"
          :specific-alt="$t(`general.csa.${csa}`)"
          width="100%"
          height="100%" />
      </div>
    </div>
  </div>
</template>

<script>
import { WptvIcon } from '@wptv/components/ui/icon'
import { mapGetters } from 'vuex'
import _get from 'lodash/get'
import API from '../../../../../api.constants'
import BookmarksMixin from '../../../../shared/bookmarks/bookmarks.mixin'

export default {
  name: 'FipTitle',
  components: { WptvIcon },
  mixins: [BookmarksMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    canBeBookmarked: {
      type: Boolean,
      default: true
    },
    preTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      getBookmarkById: 'bookmarks/getBookmarkById',
      applicationVariant: 'user/getApplicationVariant'
    }),
    bookmarkId () {
      return _get(this.getBookmarkById(this.item.id), 'bookmarkId', null)
    },
    bookmarked () {
      return this.bookmarkId !== null
    },
    csa () {
      return this.item.csa ? this.item.csa : 1
    },
    defaultTesting () {
      return this.applicationVariant === API.ABTESTING.DEFAULT
    }
  }
}
</script>

<style lang="scss" scoped>
  .fip-title {
    width: 100%;
    z-index: 9;
    color: $white;
    font-weight: 700;
    display: flex;
    align-items: flex-start;
    word-break: break-word;
    @include mediaQueries('margin', (xsmall: 15px 0, large: 0));

    h2 {
      padding: 0;
      margin: 0;
    }

    .icon-csa-wrapper {
      flex-shrink: 0;
      display: flex;
      margin-left: 10px;
      @include mediaQueries('width', (xsmall: 16px, medium: 20px, large: 26px, xlarge: 30px));
      @include mediaQueries('height', (large: 36px, xlarge: 40px));
    }
  }

</style>
